import { type ComponentsOverrides, type Theme, type TypographyVariantsOptions } from '@mui/material/styles'
import { rem } from 'polished'

const Poppins = ['Poppins', 'Arial', 'Helvetica', 'sans-serif'].toString()
const PoppinsSemiBold = ['Poppins-SemiBold', 'Arial', 'Helvetica', 'sans-serif'].toString()
const PoppinsBold = ['Poppins-Bold', 'Arial', 'Helvetica', 'sans-serif'].toString()

export const globalTypography: TypographyVariantsOptions = {
  fontFamily: Poppins,
}

export const typographyOverrides = (theme: Theme): ComponentsOverrides['MuiTypography'] => ({
  h1: {
    fontFamily: PoppinsBold,
    fontSize: rem(30),
    lineHeight: rem(38),
    fontWeight: 700,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(30),
      lineHeight: rem(38),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(34),
      lineHeight: rem(44),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(34),
      lineHeight: rem(44),
    },
  },
  h2: {
    fontFamily: PoppinsBold,
    fontSize: rem(20),
    lineHeight: rem(26),
    fontWeight: 700,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(20),
      lineHeight: rem(26),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(24),
      lineHeight: rem(30),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(24),
      lineHeight: rem(30),
    },
  },
  h3: {
    fontFamily: PoppinsBold,
    fontSize: rem(18),
    lineHeight: rem(24),
    fontWeight: 700,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(18),
      lineHeight: rem(24),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(20),
      lineHeight: rem(26),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(20),
      lineHeight: rem(26),
    },
  },
  body1: {
    fontFamily: PoppinsSemiBold,
    fontSize: rem(16),
    lineHeight: rem(22),
    fontWeight: 600,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
  },
  body2: {
    fontFamily: Poppins,
    fontSize: rem(16),
    lineHeight: rem(22),
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
  },
  paragraph: {
    fontFamily: Poppins,
    fontSize: rem(16),
    lineHeight: rem(22),
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
  },
  subtitle1: {
    fontFamily: Poppins,
    fontSize: rem(13),
    lineHeight: rem(18),
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(13),
      lineHeight: rem(18),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(13),
      lineHeight: rem(18),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(13),
      lineHeight: rem(18),
    },
  },
  // subtitle2 = subtitle1 dans le design system Figma
  subtitle2: {
    fontFamily: Poppins,
    fontSize: rem(13),
    lineHeight: rem(18),
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(13),
      lineHeight: rem(18),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(13),
      lineHeight: rem(18),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(13),
      lineHeight: rem(18),
    },
  },
  caption: {
    fontFamily: Poppins,
    fontSize: rem(11),
    lineHeight: rem(14),
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(11),
      lineHeight: rem(14),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(11),
      lineHeight: rem(14),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(11),
      lineHeight: rem(14),
    },
  },
  button: {
    fontFamily: Poppins,
    fontSize: rem(16),
    lineHeight: rem(22),
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: rem(16),
      lineHeight: rem(22),
    },
  },
})
